import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Globe } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import { useState } from "react";

export default function Header() {
  const { t, locale, setLocale } = useI18n();
  const [open, setOpen] = useState(false);

  const navClass = ({ isActive }) =>
    `text-sm font-medium transition-colors ${isActive ? "text-[#0EA5A4]" : "text-[#0C1A1A] hover:text-[#0EA5A4]"}`;

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-[#E5E7EB]" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center group ml-1" data-testid="logo-link">
          <img src="/brand/logo-everclean-wordmark.png" alt="Ever Clean Home" className="h-11 md:h-14 w-auto object-contain group-hover:scale-105 transition-transform" data-testid="site-logo-img" />
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          <NavLink to="/" end className={navClass} data-testid="nav-home">{t("nav.home")}</NavLink>
          <NavLink to="/book" className={navClass} data-testid="nav-book">{t("nav.book")}</NavLink>
          <NavLink to="/about" className={navClass} data-testid="nav-about">{t("nav.about")}</NavLink>
          <NavLink to="/for-hosts" className={navClass} data-testid="nav-for-hosts">{t("hosts.nav")}</NavLink>
          <NavLink to="/track" className={navClass} data-testid="nav-track">{t("nav.track")}</NavLink>
          <NavLink to="/faq" className={navClass} data-testid="nav-faq">{t("nav.faq")}</NavLink>
          <NavLink to="/contact" className={navClass} data-testid="nav-contact">{t("nav.contact")}</NavLink>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => setLocale(locale === "en" ? "es" : "en")}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium border border-[#E5E7EB] hover:border-[#0EA5A4] transition-colors"
            data-testid="lang-toggle"
            aria-label="Switch language"
          >
            <Globe className="w-4 h-4" />
            <span>{locale === "en" ? "EN" : "ES"}</span>
          </button>
          <Link to="/book">
            <Button className="bg-[#0EA5A4] hover:bg-[#0F766E] rounded-xl text-white shadow-sm" data-testid="header-book-cta">
              {t("nav.book")}
            </Button>
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 grid place-items-center rounded-xl border border-[#E5E7EB]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Open menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E5E7EB] bg-white" data-testid="mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-3">
            <NavLink to="/" end onClick={() => setOpen(false)} className="py-2 font-medium">{t("nav.home")}</NavLink>
            <NavLink to="/book" onClick={() => setOpen(false)} className="py-2 font-medium">{t("nav.book")}</NavLink>
            <NavLink to="/about" onClick={() => setOpen(false)} className="py-2 font-medium">{t("nav.about")}</NavLink>
            <NavLink to="/for-hosts" onClick={() => setOpen(false)} className="py-2 font-medium">{t("hosts.nav")}</NavLink>
            <NavLink to="/track" onClick={() => setOpen(false)} className="py-2 font-medium">{t("nav.track")}</NavLink>
            <NavLink to="/faq" onClick={() => setOpen(false)} className="py-2 font-medium">{t("nav.faq")}</NavLink>
            <NavLink to="/contact" onClick={() => setOpen(false)} className="py-2 font-medium">{t("nav.contact")}</NavLink>
            <div className="flex gap-2 pt-2">
              <button
                onClick={() => setLocale(locale === "en" ? "es" : "en")}
                className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-medium border border-[#E5E7EB]"
              >
                <Globe className="w-4 h-4" /> {locale === "en" ? "EN" : "ES"}
              </button>
              <Link to="/book" className="flex-1" onClick={() => setOpen(false)}>
                <Button className="w-full bg-[#0EA5A4] hover:bg-[#0F766E] rounded-xl">{t("nav.book")}</Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
